module.exports = __webpack_public_path__ + "static/img/logo.97912d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.png
// module id = Z2Ou
// module chunks = 1